import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import store from 'store'
import { AuthProvider } from 'react-oidc-context'
import 'reset-css/reset.css'
import { userManager } from 'scenes/authentication/oicd'
import './assets/fonts/fonts.css'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <AuthProvider userManager={userManager}>
      <Provider store={store}>
        <App />
      </Provider>
    </AuthProvider>
  </React.StrictMode>,
)

// create "dev frame" for non-production environments
;((env) => {
  if (!env || env === 'production') {
    return
  }
  const frame = document.createElement('div')
  frame.id = 'dev-frame'
  frame.style.cssText = `
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 99999;
    border: 4px solid #e9675b;
    pointer-events: none;
  `
  const label = document.createElement('div')
  label.innerText = env
  label.style.cssText = `
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 6px 14px;
    background-color: #e9675b;
    color: black;
    font-size: 18px;
    font-weight: bold;
  `
  frame.appendChild(label)
  document.body.appendChild(frame)
})(process.env.REACT_APP_ENV || process.env.NODE_ENV)
